webpackJsonp([177],{

/***/ 1434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_login_login_per__ = __webpack_require__(1880);
//
//
//
//
//
//
//
//

// import loginEcu from '@/components/login/login-ecu';


// function isJapi() {
// 	return process.env.COUNTRY_CODE === 'PER';
// }

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login',
	components: {
		loginPer: __WEBPACK_IMPORTED_MODULE_0__components_login_login_per__["a" /* default */]
		// loginEcu,
	}
	// computed: {
	// 	isJapi,
	// },
});

/***/ }),

/***/ 1435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(103);






var checkSession = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, checked;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$httpSales.get('devices-validation');

					case 3:
						_ref2 = _context.sent;
						checked = _ref2.data;

						if (checked.codeMessage === 'TERMINAL_SESSION_EXIST') {
							this.showGenericError('El punto de venta asignado al usuario con el que ingres\xF3 esta siendo usado por ' + checked.deviceTerminal[0].userName, 7000);
						} else if (checked.codeMessage === 'TYPE_DEVICE_TERMINAL_INVALID') {
							this.showGenericError('El punto de venta en cual esta ingresando solo esta asignado a dispositivos móviles');
						} else {
							this.goTo('products');
						}
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](0);

						if (_context.t0.status === 500) {
							this.showGenericError();
						}

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 8]]);
	}));

	return function checkSession() {
		return _ref.apply(this, arguments);
	};
}();

var signin = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var userData, response, user, inLocalStorage, token, codeProject, headers, requests, _ref4, _ref5, responseJapi, taxes, otherTaxes, userJapi, info;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						window.localStorage.clear();
						this.isLoading = true;
						userData = {
							email: this.user,
							password: this.password,
							codeApp: 'japiadmin'
						};
						_context2.prev = 3;
						_context2.next = 6;
						return this.$httpAcl.post('authenticate', userData);

					case 6:
						response = _context2.sent;
						user = response.data;
						inLocalStorage = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(user);
						token = user.token, codeProject = user.codeProject;
						headers = {
							Authorization: 'Bearer ' + token
						};
						requests = [this.$httpSales.get('employees/current', { headers: headers }), this.$httpSales.get('/catalog-sunat-details-list/TABLA17', { headers: headers }), this.$httpSales.get('/catalog-sunat-details-list/TABLA16', { headers: headers })];
						_context2.next = 14;
						return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(requests);

					case 14:
						_ref4 = _context2.sent;
						_ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref4, 3);
						responseJapi = _ref5[0];
						taxes = _ref5[1];
						otherTaxes = _ref5[2];
						userJapi = responseJapi.data;

						localStorage.setItem("admin", inLocalStorage);
						localStorage.setItem("admin" + '::codeProject', codeProject);
						localStorage.setItem("admin" + '::token', token);
						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('acl-id', userJapi.aclUserId);
						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('acl-code', userJapi.aclUserCode);
						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('admin-user', userJapi);
						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('general-taxes', taxes.data);
						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('other-taxes', otherTaxes.data);
						this.$bus.$emit('USER_INFO', userJapi);
						this.$ga.set('userId', userJapi.aclUserCode);
						this.countryId = userJapi.company.comCountryId;
						this.loadPlasticTaxes();
						this.checkSession();
						_context2.next = 38;
						break;

					case 35:
						_context2.prev = 35;
						_context2.t0 = _context2['catch'](3);

						if (_context2.t0.status === 401) {
							if (_context2.t0.data.code === 1153) {
								info = _context2.t0.data.infoData;

								this.showGenericError('Actualmente esta conectado desde el dispositivo marca ' + info.infoDevice.brand + ' modelo ' + info.infoDevice.model, 100000);
							} else if (_context2.t0.data.message === 'USER_WITH_PREVIOUS_CONNECTION') {
								this.showGenericError('Ya existe una sesión activa con el usuario ingresado.');
							}
						} else {
							this.showGenericError('Sus credenciales no son válidas');
						}

					case 38:
						_context2.prev = 38;

						this.isLoading = false;
						return _context2.finish(38);

					case 41:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[3, 35, 38, 41]]);
	}));

	return function signin() {
		return _ref3.apply(this, arguments);
	};
}();

var loadPlasticTaxes = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _ref7, response;

		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$httpSales.get('/electronic-taxes/' + this.countryId + '/default');

					case 3:
						_ref7 = _context3.sent;
						response = _ref7.data;

						__WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].setLocalData('tax-icb', response);
						_context3.next = 11;
						break;

					case 8:
						_context3.prev = 8;
						_context3.t0 = _context3['catch'](0);

						this.showGenericError();

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 8]]);
	}));

	return function loadPlasticTaxes() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function isLoged() {
	var token = window.localStorage.getItem("admin" + '::token');
	return token !== undefined && token != null && token !== '';
}

function data() {
	return {
		backgroundCompany: '/static/img/portada_referidos_4.webp',
		countryId: null,
		iconPassword: '/static/img/key.svg',
		iconUser: '/static/img/user.svg',
		companyLoginLogo: '/static/img/logo-normal.svg',
		user: '',
		password: '',
		isLoading: false,
		phone_number: +51924891210
		// backgroundCompany: '/static/img/portada_referidos_2.png',
		// backgroundCompany: '/static/img/portada_referidos.png',
		// backgroundCompany: process.env.COMPANY_LOGIN_BACKGROUND,
		// iconPassword: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/key-(1).svg',
		// iconUser: 'https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/group-14-(1).svg',
		// companyLoginLogo: process.env.COMPANY_LOGIN_LOGO,
	};
}

function mounted() {
	if (this.isLoged()) {
		this.goTo('products');
	}
	/* else {
 	this.checkSession();
 } */
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login-per',
	mounted: mounted,
	data: data,
	methods: {
		checkSession: checkSession,
		loadPlasticTaxes: loadPlasticTaxes,
		signin: signin,
		isLoged: isLoged
	}
});

/***/ }),

/***/ 1880:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_per_vue__ = __webpack_require__(1435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ae5166_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_per_vue__ = __webpack_require__(1883);
function injectStyle (ssrContext) {
  __webpack_require__(1881)
}
var normalizeComponent = __webpack_require__(205)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63ae5166"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_per_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63ae5166_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_per_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1882);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(683)("3b0859d2", content, true, {});

/***/ }),

/***/ 1882:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(682)(true);
// imports


// module
exports.push([module.i, ".main-login[data-v-63ae5166]{display:grid;grid-template-columns:1fr 1fr;grid-gap:3rem;min-height:100vh;margin:0 auto;max-width:1100px}@media (max-width:640px){.main-login[data-v-63ae5166]{grid-template-columns:1fr}}.main-login .login-col[data-v-63ae5166]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (max-width:640px){.main-login .bg-imagen-login[data-v-63ae5166]{display:none}}.main-login .bg-imagen-login img[data-v-63ae5166]{max-width:500px;width:100%;margin-top:-57px}.main-login .login[data-v-63ae5166]{width:100%;max-width:300px}.main-login .login .login-logo[data-v-63ae5166]{margin-bottom:60px;text-align:center}.main-login .login .login-header[data-v-63ae5166]{color:#5364e1;font-family:Lato_regular;font-size:16px;text-align:center}.main-login .login .login-inputs[data-v-63ae5166]{font-size:24px;margin-bottom:30px;width:100%}.main-login .login .login-inputs .login-inputs-txt[data-v-63ae5166]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-63ae5166]{width:90%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-63ae5166]{font-family:Opens_regular;font-size:16px;color:#212d68;height:60px;outline:none;width:100%}.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-63ae5166]{font-family:Opens_regular;font-size:12px;color:red;float:left}.main-login .login .login-inputs .login-spacer[data-v-63ae5166]{border:1px solid #616161;opacity:.7;width:100%}.main-login .login .login-footer .login-footer-pass[data-v-63ae5166]{color:#818cbb;font-family:Opens_regular;font-size:14px;margin:0;text-align:center;margin-top:1.5rem;cursor:pointer;display:block;text-decoration:none}.main-login .login .login-footer .login-btn[data-v-63ae5166]{width:100%;display:block;background:#5364e1;margin:0;color:#fff}.main-login .login-info .login-info-text[data-v-63ae5166]{color:#5364e1;font-family:Lato_regular;font-size:18px;margin-bottom:30px}.main-login .login-info .login-info-btn[data-v-63ae5166]{background-color:#279bd8;border-radius:5px;color:#5364e1;font-family:Lato_regular;font-size:24px;height:45px;line-height:45px;margin:auto;text-align:center;width:127px;cursor:pointer;display:block;text-decoration:none}.main-login .login-info .login-info-btn[data-v-63ae5166]:active{-webkit-transform:scale(.9);transform:scale(.9)}@-webkit-keyframes autofill-data-v-63ae5166{to{color:#5364e1;background:transparent}}@keyframes autofill-data-v-63ae5166{to{color:#5364e1;background:transparent}}input[data-v-63ae5166]:-webkit-autofill{-webkit-animation-name:autofill-data-v-63ae5166;animation-name:autofill-data-v-63ae5166;-webkit-animation-fill-mode:both;animation-fill-mode:both;background-color:transparent!important}.\\--container-promotion-banner[data-v-63ae5166]{border-radius:4px;overflow:hidden;background-color:#eff3ff;color:#5364e1;text-align:center}.\\--container-promotion-banner .\\--title[data-v-63ae5166]{font-weight:100;line-height:1.3;color:#6b71a0;font-size:16px;font-weight:700}.\\--container-promotion-banner .\\--title strong[data-v-63ae5166]{font-weight:700;font-size:20px;color:#5364e1}.\\--container-promotion-banner .\\--sub-title[data-v-63ae5166]{color:#525574;margin:4px 0 8px}.\\--container-promotion-banner .\\--big-btn-info[data-v-63ae5166]{background-color:#5763cf;color:#fff;padding:10px 5px}.\\--more-information[data-v-63ae5166]{text-align:center;color:#2c3a57;margin:15px 0 0}.\\--more-information p[data-v-63ae5166]{margin:0}", "", {"version":3,"sources":["/codebuild/output/src4069214433/src/src/components/login/login-per.vue"],"names":[],"mappings":"AACA,6BACE,aAAc,AACd,8BAA+B,AAC/B,cAAe,AACf,iBAAkB,AAClB,cAAe,AACf,gBAAkB,CACnB,AACD,yBACA,6BACM,yBAA2B,CAChC,CACA,AACD,wCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,yBACA,8CACM,YAAc,CACnB,CACA,AACD,kDACI,gBAAiB,AACjB,WAAY,AACZ,gBAAkB,CACrB,AACD,oCACI,WAAY,AACZ,eAAiB,CACpB,AACD,gDACM,mBAAoB,AACpB,iBAAmB,CACxB,AACD,kDACM,cAAe,AACf,yBAA4B,AAC5B,eAAgB,AAChB,iBAAmB,CACxB,AACD,kDACM,eAAgB,AAChB,mBAAoB,AACpB,UAAY,CACjB,AACD,oEACQ,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CAC9C,AACD,wFACU,SAAW,CACpB,AACD,qGACY,0BAA6B,AAC7B,eAAgB,AAChB,cAAe,AACf,YAAa,AACb,aAAc,AACd,UAAY,CACvB,AACD,6GACY,0BAA6B,AAC7B,eAAgB,AAChB,UAAe,AACf,UAAY,CACvB,AACD,gEACQ,yBAA0B,AAC1B,WAAa,AACb,UAAY,CACnB,AACD,qEACM,cAAe,AACf,0BAA6B,AAC7B,eAAgB,AAChB,SAAU,AACV,kBAAmB,AACnB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,oBAAsB,CAC3B,AACD,6DACM,WAAY,AACZ,cAAe,AACf,mBAAoB,AACpB,SAAU,AACV,UAAY,CACjB,AACD,0DACI,cAAe,AACf,yBAA4B,AAC5B,eAAgB,AAChB,kBAAoB,CACvB,AACD,yDACI,yBAA0B,AAC1B,kBAAmB,AACnB,cAAe,AACf,yBAA4B,AAC5B,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,cAAe,AACf,oBAAsB,CACzB,AACD,gEACI,4BAA8B,AACtB,mBAAsB,CACjC,AACD,4CACA,GACI,cAAe,AACf,sBAAwB,CAC3B,CACA,AACD,oCACA,GACI,cAAe,AACf,sBAAwB,CAC3B,CACA,AACD,wCACE,gDAAiD,AACzC,wCAAyC,AACjD,iCAAkC,AAC1B,yBAA0B,AAClC,sCAAyC,CAC1C,AACD,gDACE,kBAAmB,AACnB,gBAAiB,AACjB,yBAA0B,AAC1B,cAAe,AACf,iBAAmB,CACpB,AACD,0DACI,gBAAiB,AACjB,gBAAiB,AACjB,cAAe,AACf,eAAgB,AAChB,eAAiB,CACpB,AACD,iEACM,gBAAiB,AACjB,eAAgB,AAChB,aAAe,CACpB,AACD,8DACI,cAAe,AACf,gBAAkB,CACrB,AACD,iEACI,yBAA0B,AAC1B,WAAY,AACZ,gBAAkB,CACrB,AACD,sCACE,kBAAmB,AACnB,cAAe,AACf,eAAiB,CAClB,AACD,wCACI,QAAU,CACb","file":"login-per.vue","sourcesContent":["\n.main-login[data-v-63ae5166] {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 3rem;\n  min-height: 100vh;\n  margin: 0 auto;\n  max-width: 1100px;\n}\n@media (max-width: 640px) {\n.main-login[data-v-63ae5166] {\n      grid-template-columns: 1fr;\n}\n}\n.main-login .login-col[data-v-63ae5166] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n@media (max-width: 640px) {\n.main-login .bg-imagen-login[data-v-63ae5166] {\n      display: none;\n}\n}\n.main-login .bg-imagen-login img[data-v-63ae5166] {\n    max-width: 500px;\n    width: 100%;\n    margin-top: -57px;\n}\n.main-login .login[data-v-63ae5166] {\n    width: 100%;\n    max-width: 300px;\n}\n.main-login .login .login-logo[data-v-63ae5166] {\n      margin-bottom: 60px;\n      text-align: center;\n}\n.main-login .login .login-header[data-v-63ae5166] {\n      color: #5364e1;\n      font-family: \"Lato_regular\";\n      font-size: 16px;\n      text-align: center;\n}\n.main-login .login .login-inputs[data-v-63ae5166] {\n      font-size: 24px;\n      margin-bottom: 30px;\n      width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt[data-v-63ae5166] {\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: justify;\n            -ms-flex-pack: justify;\n                justify-content: space-between;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group[data-v-63ae5166] {\n          width: 90%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-input[data-v-63ae5166] {\n            font-family: \"Opens_regular\";\n            font-size: 16px;\n            color: #212D68;\n            height: 60px;\n            outline: none;\n            width: 100%;\n}\n.main-login .login .login-inputs .login-inputs-txt .login-inputs-group .login-error-message[data-v-63ae5166] {\n            font-family: \"Opens_regular\";\n            font-size: 12px;\n            color: #ff0000;\n            float: left;\n}\n.main-login .login .login-inputs .login-spacer[data-v-63ae5166] {\n        border: 1px solid #616161;\n        opacity: 0.7;\n        width: 100%;\n}\n.main-login .login .login-footer .login-footer-pass[data-v-63ae5166] {\n      color: #818cbb;\n      font-family: \"Opens_regular\";\n      font-size: 14px;\n      margin: 0;\n      text-align: center;\n      margin-top: 1.5rem;\n      cursor: pointer;\n      display: block;\n      text-decoration: none;\n}\n.main-login .login .login-footer .login-btn[data-v-63ae5166] {\n      width: 100%;\n      display: block;\n      background: #5364e1;\n      margin: 0;\n      color: #FFF;\n}\n.main-login .login-info .login-info-text[data-v-63ae5166] {\n    color: #5364e1;\n    font-family: \"Lato_regular\";\n    font-size: 18px;\n    margin-bottom: 30px;\n}\n.main-login .login-info .login-info-btn[data-v-63ae5166] {\n    background-color: #279bd8;\n    border-radius: 5px;\n    color: #5364e1;\n    font-family: \"Lato_regular\";\n    font-size: 24px;\n    height: 45px;\n    line-height: 45px;\n    margin: auto;\n    text-align: center;\n    width: 127px;\n    cursor: pointer;\n    display: block;\n    text-decoration: none;\n}\n.main-login .login-info .login-info-btn[data-v-63ae5166]:active {\n    -webkit-transform: scale(0.9);\n            transform: scale(0.9);\n}\n@-webkit-keyframes autofill-data-v-63ae5166 {\nto {\n    color: #5364e1;\n    background: transparent;\n}\n}\n@keyframes autofill-data-v-63ae5166 {\nto {\n    color: #5364e1;\n    background: transparent;\n}\n}\ninput[data-v-63ae5166]:-webkit-autofill {\n  -webkit-animation-name: autofill-data-v-63ae5166;\n          animation-name: autofill-data-v-63ae5166;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  background-color: transparent !important;\n}\n.--container-promotion-banner[data-v-63ae5166] {\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #eff3ff;\n  color: #5364e1;\n  text-align: center;\n}\n.--container-promotion-banner .--title[data-v-63ae5166] {\n    font-weight: 100;\n    line-height: 1.3;\n    color: #6b71a0;\n    font-size: 16px;\n    font-weight: 700;\n}\n.--container-promotion-banner .--title strong[data-v-63ae5166] {\n      font-weight: 700;\n      font-size: 20px;\n      color: #5364e1;\n}\n.--container-promotion-banner .--sub-title[data-v-63ae5166] {\n    color: #525574;\n    margin: 4px 0 8px;\n}\n.--container-promotion-banner .--big-btn-info[data-v-63ae5166] {\n    background-color: #5763cf;\n    color: #FFF;\n    padding: 10px 5px;\n}\n.--more-information[data-v-63ae5166] {\n  text-align: center;\n  color: #2c3a57;\n  margin: 15px 0 0;\n}\n.--more-information p[data-v-63ae5166] {\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-login"},[_c('div',{staticClass:"login-col"},[_c('section',{staticClass:"login"},[_c('div',{staticClass:"login-logo text-center"},[_c('img',{attrs:{"src":_vm.companyLoginLogo,"alt":"admin-logo","width":"180"}})]),_vm._v(" "),_c('form',{staticClass:"login-inputs",attrs:{"id":"login-form"},on:{"submit":function($event){$event.preventDefault();return _vm.signin($event)}}},[_c('div',{staticClass:"login-inputs-txt"},[_c('img',{attrs:{"src":_vm.iconUser,"alt":"user","width":"16"}}),_vm._v(" "),_c('div',{staticClass:"login-inputs-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user),expression:"user"}],staticClass:"login-input",attrs:{"type":"email","placeholder":"Usuario","autocomplete":"off","required":""},domProps:{"value":(_vm.user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user=$event.target.value}}})])]),_vm._v(" "),_c('hr',{staticClass:"login-spacer"}),_vm._v(" "),_c('div',{staticClass:"login-inputs-txt"},[_c('img',{attrs:{"src":_vm.iconPassword,"alt":"password","width":"16"}}),_vm._v(" "),_c('div',{staticClass:"login-inputs-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"login-input",attrs:{"type":"password","placeholder":"Contraseña","autocomplete":"off","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"login-footer"},[_c('v-btn',{staticClass:"login-btn",class:{ disabled: _vm.isLoading },attrs:{"type":"submit","form":"login-form","color":"btn-login","loading":_vm.isLoading,"accesskey":"13","disabled":_vm.isLoading}},[_vm._v("\n\t\t\t\t\tEntrar\n\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"login-footer-pass",attrs:{"href":("https://wa.me/" + _vm.phone_number + "?text=Hola, tengo un problema al iniciar sesión en la plataforma."),"target":"_blank"}},[_vm._v("¿Olvidaste tu contraseña?")])],1)])]),_vm._v(" "),_c('div',{staticClass:"login-col bg-imagen-login"},[_c('div',[_c('div',[_c('img',{attrs:{"src":_vm.backgroundCompany,"alt":"banner login","title":"Login de tandia"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1884:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('login-per')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(1434);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664ef56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(1884);
var normalizeComponent = __webpack_require__(205)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4664ef56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/177.468eabf6a91ae093ba8f.js